export const CASHBOX_QUERY = {
  CASHBOX: 'cashbox',
  CASHBOX_SUCCESS: 'cashbox-success',
  CASHBOX_ERROR: 'cashbox-error',
  CASHBOX_EXT: 'cashbox-ext',
  VIEW: {
    KEY: 'view',
    VALUE: {
      IFRAME: 'iframe',
    },
  },
  UUID: 'uuid',
}

export const CASHBOX_EVENTS = {
  LEAVE_CASHBOX: 'LEAVE_CASHBOX',
}

export const CASHBOX_EVENTS_WS = {
  MODAL_BALANCE_DEPOSIT: 'DEPOSIT',
  MODAL_DECLINE_PAYOUT_REQUEST: 'DECLINE_PAYOUT_REQUEST',
}

export const BE_PAY_IN_METHOD__REDIRECT_TYPE = {
  IFRAME: 'iframe',
}

export const CASHBOX_PAGE = {
  CASHBOX: 'cashbox',
  PAYIN_SUCCESS: 'payin-success',
  PAYIN_ERROR: 'payin-error',
  PAYIN_STATUS_EXT: 'payin-status-ext',
}